/* eslint-disable */

/**
 * @author Eugene Zatepyakin / http://inspirit.ru/
 */

// namespace ?
var jsfeat = jsfeat || { REVISION: 'ALPHA' };

(function(global) {
  'use strict';
  //

  // CONSTANTS
  var EPSILON = 0.0000001192092896;
  var FLT_MIN = 1e-37;

  // implementation from CCV project
  // currently working only with u8,s32,f32
  var U8_t = 0x0100,
    S32_t = 0x0200,
    F32_t = 0x0400,
    S64_t = 0x0800,
    F64_t = 0x1000;

  var C1_t = 0x01,
    C2_t = 0x02,
    C3_t = 0x03,
    C4_t = 0x04;

  var _data_type_size = new Int32Array([
    -1,
    1,
    4,
    -1,
    4,
    -1,
    -1,
    -1,
    8,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8
  ]);

  var get_data_type = (function() {
    return function(type) {
      return type & 0xff00;
    };
  })();

  var get_channel = (function() {
    return function(type) {
      return type & 0xff;
    };
  })();

  var get_data_type_size = (function() {
    return function(type) {
      return _data_type_size[(type & 0xff00) >> 8];
    };
  })();

  // color conversion
  var COLOR_RGBA2GRAY = 0;
  var COLOR_RGB2GRAY = 1;
  var COLOR_BGRA2GRAY = 2;
  var COLOR_BGR2GRAY = 3;

  var data_t = (function() {
    function data_t(size_in_bytes, buffer) {
      // we need align size to multiple of 8
      this.size = ((size_in_bytes + 7) | 0) & -8;
      if (typeof buffer === 'undefined') {
        this.buffer = new ArrayBuffer(this.size);
      } else {
        this.buffer = buffer;
        this.size = buffer.length;
      }
      this.u8 = new Uint8Array(this.buffer);
      this.i32 = new Int32Array(this.buffer);
      this.f32 = new Float32Array(this.buffer);
      this.f64 = new Float64Array(this.buffer);
    }
    return data_t;
  })();

  var matrix_t = (function() {
    // columns, rows, data_type
    function matrix_t(c, r, data_type, data_buffer) {
      this.type = get_data_type(data_type) | 0;
      this.channel = get_channel(data_type) | 0;
      this.cols = c | 0;
      this.rows = r | 0;
      if (typeof data_buffer === 'undefined') {
        this.allocate();
      } else {
        this.buffer = data_buffer;
        // data user asked for
        this.data =
          this.type & U8_t
            ? this.buffer.u8
            : this.type & S32_t
            ? this.buffer.i32
            : this.type & F32_t
            ? this.buffer.f32
            : this.buffer.f64;
      }
    }
    matrix_t.prototype.allocate = function() {
      // clear references
      delete this.data;
      delete this.buffer;
      //
      this.buffer = new data_t(
        this.cols * get_data_type_size(this.type) * this.channel * this.rows
      );
      this.data =
        this.type & U8_t
          ? this.buffer.u8
          : this.type & S32_t
          ? this.buffer.i32
          : this.type & F32_t
          ? this.buffer.f32
          : this.buffer.f64;
    };
    matrix_t.prototype.copy_to = function(other) {
      var od = other.data,
        td = this.data;
      var i = 0,
        n = (this.cols * this.rows * this.channel) | 0;
      for (; i < n - 4; i += 4) {
        od[i] = td[i];
        od[i + 1] = td[i + 1];
        od[i + 2] = td[i + 2];
        od[i + 3] = td[i + 3];
      }
      for (; i < n; ++i) {
        od[i] = td[i];
      }
    };
    matrix_t.prototype.resize = function(c, r, ch) {
      if (typeof ch === 'undefined') {
        ch = this.channel;
      }
      // relocate buffer only if new size doesnt fit
      var new_size = c * get_data_type_size(this.type) * ch * r;
      if (new_size > this.buffer.size) {
        this.cols = c;
        this.rows = r;
        this.channel = ch;
        this.allocate();
      } else {
        this.cols = c;
        this.rows = r;
        this.channel = ch;
      }
    };

    return matrix_t;
  })();

  var keypoint_t = (function() {
    function keypoint_t(x, y, score, level, angle) {
      if (typeof x === 'undefined') {
        x = 0;
      }
      if (typeof y === 'undefined') {
        y = 0;
      }
      if (typeof score === 'undefined') {
        score = 0;
      }
      if (typeof level === 'undefined') {
        level = 0;
      }
      if (typeof angle === 'undefined') {
        angle = -1.0;
      }

      this.x = x;
      this.y = y;
      this.score = score;
      this.level = level;
      this.angle = angle;
    }
    return keypoint_t;
  })();

  // data types
  global.U8_t = U8_t;
  global.S32_t = S32_t;
  global.F32_t = F32_t;
  global.S64_t = S64_t;
  global.F64_t = F64_t;
  // data channels
  global.C1_t = C1_t;
  global.C2_t = C2_t;
  global.C3_t = C3_t;
  global.C4_t = C4_t;

  // popular formats
  global.U8C1_t = U8_t | C1_t;
  global.U8C3_t = U8_t | C3_t;
  global.U8C4_t = U8_t | C4_t;

  global.F32C1_t = F32_t | C1_t;
  global.F32C2_t = F32_t | C2_t;
  global.S32C1_t = S32_t | C1_t;
  global.S32C2_t = S32_t | C2_t;

  // constants
  global.EPSILON = EPSILON;
  global.FLT_MIN = FLT_MIN;

  // color convert
  global.COLOR_RGBA2GRAY = COLOR_RGBA2GRAY;
  global.COLOR_RGB2GRAY = COLOR_RGB2GRAY;
  global.COLOR_BGRA2GRAY = COLOR_BGRA2GRAY;
  global.COLOR_BGR2GRAY = COLOR_BGR2GRAY;

  // options
  global.get_data_type = get_data_type;
  global.get_channel = get_channel;
  global.get_data_type_size = get_data_type_size;

  global.data_t = data_t;
  global.matrix_t = matrix_t;
  global.keypoint_t = keypoint_t;
})(jsfeat);
/**
 * @author Eugene Zatepyakin / http://inspirit.ru/
 */

(function(global) {
  'use strict';
  //

  var cache = (function() {
    // very primitive array cache, still need testing if it helps
    // of course V8 has its own powerful cache sys but i'm not sure
    // it caches several multichannel 640x480 buffer creations each frame

    var _pool_node_t = (function() {
      function _pool_node_t(size_in_bytes) {
        this.next = null;
        this.data = new jsfeat.data_t(size_in_bytes);
        this.size = this.data.size;
        this.buffer = this.data.buffer;
        this.u8 = this.data.u8;
        this.i32 = this.data.i32;
        this.f32 = this.data.f32;
        this.f64 = this.data.f64;
      }
      _pool_node_t.prototype.resize = function(size_in_bytes) {
        delete this.data;
        this.data = new jsfeat.data_t(size_in_bytes);
        this.size = this.data.size;
        this.buffer = this.data.buffer;
        this.u8 = this.data.u8;
        this.i32 = this.data.i32;
        this.f32 = this.data.f32;
        this.f64 = this.data.f64;
      };
      return _pool_node_t;
    })();

    var _pool_head, _pool_tail;
    var _pool_size = 0;

    return {
      allocate: function(capacity, data_size) {
        _pool_head = _pool_tail = new _pool_node_t(data_size);
        for (var i = 0; i < capacity; ++i) {
          var node = new _pool_node_t(data_size);
          _pool_tail = _pool_tail.next = node;

          _pool_size++;
        }
      },

      get_buffer: function(size_in_bytes) {
        // assume we have enough free nodes
        var node = _pool_head;
        _pool_head = _pool_head.next;
        _pool_size--;

        if (size_in_bytes > node.size) {
          node.resize(size_in_bytes);
        }

        return node;
      },

      put_buffer: function(node) {
        _pool_tail = _pool_tail.next = node;
        _pool_size++;
      }
    };
  })();

  global.cache = cache;
  // for now we dont need more than 30 buffers
  // if having cache sys really helps we can add auto extending sys
  cache.allocate(30, 640 * 4);
})(jsfeat);
/**
 * @author Eugene Zatepyakin / http://inspirit.ru/
 */

(function(global) {
  'use strict';
  //

  var math = (function() {
    return {
      get_gaussian_kernel: function(size, sigma, kernel, data_type) {
        var i = 0,
          x = 0.0,
          t = 0.0,
          sigma_x = 0.0,
          scale_2x = 0.0;
        var sum = 0.0;
        var kern_node = jsfeat.cache.get_buffer(size << 2);
        var _kernel = kern_node.f32; //new Float32Array(size);

        if ((size & 1) == 1 && size <= 7 && sigma <= 0) {
          switch (size >> 1) {
            case 0:
              _kernel[0] = 1.0;
              sum = 1.0;
              break;
            case 1:
              (_kernel[0] = 0.25), (_kernel[1] = 0.5), (_kernel[2] = 0.25);
              sum = 0.25 + 0.5 + 0.25;
              break;
            case 2:
              (_kernel[0] = 0.0625),
                (_kernel[1] = 0.25),
                (_kernel[2] = 0.375),
                (_kernel[3] = 0.25),
                (_kernel[4] = 0.0625);
              sum = 0.0625 + 0.25 + 0.375 + 0.25 + 0.0625;
              break;
            case 3:
              (_kernel[0] = 0.03125),
                (_kernel[1] = 0.109375),
                (_kernel[2] = 0.21875),
                (_kernel[3] = 0.28125),
                (_kernel[4] = 0.21875),
                (_kernel[5] = 0.109375),
                (_kernel[6] = 0.03125);
              sum =
                0.03125 +
                0.109375 +
                0.21875 +
                0.28125 +
                0.21875 +
                0.109375 +
                0.03125;
              break;
          }
        } else {
          sigma_x = sigma > 0 ? sigma : ((size - 1) * 0.5 - 1.0) * 0.3 + 0.8;
          scale_2x = -0.5 / (sigma_x * sigma_x);

          for (; i < size; ++i) {
            x = i - (size - 1) * 0.5;
            t = Math.exp(scale_2x * x * x);

            _kernel[i] = t;
            sum += t;
          }
        }

        if (data_type & jsfeat.U8_t) {
          // int based kernel
          sum = 256.0 / sum;
          for (i = 0; i < size; ++i) {
            kernel[i] = (_kernel[i] * sum + 0.5) | 0;
          }
        } else {
          // classic kernel
          sum = 1.0 / sum;
          for (i = 0; i < size; ++i) {
            kernel[i] = _kernel[i] * sum;
          }
        }

        jsfeat.cache.put_buffer(kern_node);
      }
    };
  })();

  global.math = math;
})(jsfeat);
/**
 * @author Eugene Zatepyakin / http://inspirit.ru/
 *
 */

(function(global) {
  'use strict';
  //

  var linalg = (function() {
    var swap = function(A, i0, i1, t) {
      t = A[i0];
      A[i0] = A[i1];
      A[i1] = t;
    };

    return {
      lu_solve: function(A, B) {
        var i = 0,
          j = 0,
          k = 0,
          p = 1,
          astep = A.cols;
        var ad = A.data,
          bd = B.data;
        var t, alpha, d, s;

        for (i = 0; i < astep; i++) {
          k = i;
          for (j = i + 1; j < astep; j++) {
            if (Math.abs(ad[j * astep + i]) > Math.abs(ad[k * astep + i])) {
              k = j;
            }
          }

          if (Math.abs(ad[k * astep + i]) < jsfeat.EPSILON) {
            return 0; // FAILED
          }

          if (k != i) {
            for (j = i; j < astep; j++) {
              swap(ad, i * astep + j, k * astep + j, t);
            }

            swap(bd, i, k, t);
            p = -p;
          }

          d = -1.0 / ad[i * astep + i];

          for (j = i + 1; j < astep; j++) {
            alpha = ad[j * astep + i] * d;

            for (k = i + 1; k < astep; k++) {
              ad[j * astep + k] += alpha * ad[i * astep + k];
            }

            bd[j] += alpha * bd[i];
          }

          ad[i * astep + i] = -d;
        }

        for (i = astep - 1; i >= 0; i--) {
          s = bd[i];
          for (k = i + 1; k < astep; k++) {
            s -= ad[i * astep + k] * bd[k];
          }
          bd[i] = s * ad[i * astep + i];
        }

        return 1; // OK
      },

      eigenVV: function(A, vects, vals) {
        var n = A.cols,
          i = n * n;
        var dt = A.type | jsfeat.C1_t;

        var a_buff = jsfeat.cache.get_buffer((n * n) << 3);
        var w_buff = jsfeat.cache.get_buffer(n << 3);
        var a_mt = new jsfeat.matrix_t(n, n, dt, a_buff.data);
        var w_mt = new jsfeat.matrix_t(1, n, dt, w_buff.data);

        while (--i >= 0) {
          a_mt.data[i] = A.data[i];
        }

        JacobiImpl(a_mt.data, n, w_mt.data, vects ? vects.data : null, n, n);

        if (vals) {
          while (--n >= 0) {
            vals.data[n] = w_mt.data[n];
          }
        }

        jsfeat.cache.put_buffer(a_buff);
        jsfeat.cache.put_buffer(w_buff);
      }
    };
  })();

  global.linalg = linalg;
})(jsfeat);

/**
 * @author Eugene Zatepyakin / http://inspirit.ru/
 */

(function(global) {
  'use strict';
  //

  var imgproc = (function() {
    var _convol_u8 = function(
      buf,
      src_d,
      dst_d,
      w,
      h,
      filter,
      kernel_size,
      half_kernel
    ) {
      var i = 0,
        j = 0,
        k = 0,
        sp = 0,
        dp = 0,
        sum = 0,
        sum1 = 0,
        sum2 = 0,
        sum3 = 0,
        f0 = filter[0],
        fk = 0;
      var w2 = w << 1,
        w3 = w * 3,
        w4 = w << 2;
      // hor pass
      for (; i < h; ++i) {
        sum = src_d[sp];
        for (j = 0; j < half_kernel; ++j) {
          buf[j] = sum;
        }
        for (j = 0; j <= w - 2; j += 2) {
          buf[j + half_kernel] = src_d[sp + j];
          buf[j + half_kernel + 1] = src_d[sp + j + 1];
        }
        for (; j < w; ++j) {
          buf[j + half_kernel] = src_d[sp + j];
        }
        sum = src_d[sp + w - 1];
        for (j = w; j < half_kernel + w; ++j) {
          buf[j + half_kernel] = sum;
        }
        for (j = 0; j <= w - 4; j += 4) {
          (sum = buf[j] * f0),
            (sum1 = buf[j + 1] * f0),
            (sum2 = buf[j + 2] * f0),
            (sum3 = buf[j + 3] * f0);
          for (k = 1; k < kernel_size; ++k) {
            fk = filter[k];
            sum += buf[k + j] * fk;
            sum1 += buf[k + j + 1] * fk;
            sum2 += buf[k + j + 2] * fk;
            sum3 += buf[k + j + 3] * fk;
          }
          dst_d[dp + j] = Math.min(sum >> 8, 255);
          dst_d[dp + j + 1] = Math.min(sum1 >> 8, 255);
          dst_d[dp + j + 2] = Math.min(sum2 >> 8, 255);
          dst_d[dp + j + 3] = Math.min(sum3 >> 8, 255);
        }
        for (; j < w; ++j) {
          sum = buf[j] * f0;
          for (k = 1; k < kernel_size; ++k) {
            sum += buf[k + j] * filter[k];
          }
          dst_d[dp + j] = Math.min(sum >> 8, 255);
        }
        sp += w;
        dp += w;
      }

      // vert pass
      for (i = 0; i < w; ++i) {
        sum = dst_d[i];
        for (j = 0; j < half_kernel; ++j) {
          buf[j] = sum;
        }
        k = i;
        for (j = 0; j <= h - 2; j += 2, k += w2) {
          buf[j + half_kernel] = dst_d[k];
          buf[j + half_kernel + 1] = dst_d[k + w];
        }
        for (; j < h; ++j, k += w) {
          buf[j + half_kernel] = dst_d[k];
        }
        sum = dst_d[(h - 1) * w + i];
        for (j = h; j < half_kernel + h; ++j) {
          buf[j + half_kernel] = sum;
        }
        dp = i;
        for (j = 0; j <= h - 4; j += 4, dp += w4) {
          (sum = buf[j] * f0),
            (sum1 = buf[j + 1] * f0),
            (sum2 = buf[j + 2] * f0),
            (sum3 = buf[j + 3] * f0);
          for (k = 1; k < kernel_size; ++k) {
            fk = filter[k];
            sum += buf[k + j] * fk;
            sum1 += buf[k + j + 1] * fk;
            sum2 += buf[k + j + 2] * fk;
            sum3 += buf[k + j + 3] * fk;
          }
          dst_d[dp] = Math.min(sum >> 8, 255);
          dst_d[dp + w] = Math.min(sum1 >> 8, 255);
          dst_d[dp + w2] = Math.min(sum2 >> 8, 255);
          dst_d[dp + w3] = Math.min(sum3 >> 8, 255);
        }
        for (; j < h; ++j, dp += w) {
          sum = buf[j] * f0;
          for (k = 1; k < kernel_size; ++k) {
            sum += buf[k + j] * filter[k];
          }
          dst_d[dp] = Math.min(sum >> 8, 255);
        }
      }
    };

    var _convol = function(
      buf,
      src_d,
      dst_d,
      w,
      h,
      filter,
      kernel_size,
      half_kernel
    ) {
      var i = 0,
        j = 0,
        k = 0,
        sp = 0,
        dp = 0,
        sum = 0.0,
        sum1 = 0.0,
        sum2 = 0.0,
        sum3 = 0.0,
        f0 = filter[0],
        fk = 0.0;
      var w2 = w << 1,
        w3 = w * 3,
        w4 = w << 2;
      // hor pass
      for (; i < h; ++i) {
        sum = src_d[sp];
        for (j = 0; j < half_kernel; ++j) {
          buf[j] = sum;
        }
        for (j = 0; j <= w - 2; j += 2) {
          buf[j + half_kernel] = src_d[sp + j];
          buf[j + half_kernel + 1] = src_d[sp + j + 1];
        }
        for (; j < w; ++j) {
          buf[j + half_kernel] = src_d[sp + j];
        }
        sum = src_d[sp + w - 1];
        for (j = w; j < half_kernel + w; ++j) {
          buf[j + half_kernel] = sum;
        }
        for (j = 0; j <= w - 4; j += 4) {
          (sum = buf[j] * f0),
            (sum1 = buf[j + 1] * f0),
            (sum2 = buf[j + 2] * f0),
            (sum3 = buf[j + 3] * f0);
          for (k = 1; k < kernel_size; ++k) {
            fk = filter[k];
            sum += buf[k + j] * fk;
            sum1 += buf[k + j + 1] * fk;
            sum2 += buf[k + j + 2] * fk;
            sum3 += buf[k + j + 3] * fk;
          }
          dst_d[dp + j] = sum;
          dst_d[dp + j + 1] = sum1;
          dst_d[dp + j + 2] = sum2;
          dst_d[dp + j + 3] = sum3;
        }
        for (; j < w; ++j) {
          sum = buf[j] * f0;
          for (k = 1; k < kernel_size; ++k) {
            sum += buf[k + j] * filter[k];
          }
          dst_d[dp + j] = sum;
        }
        sp += w;
        dp += w;
      }

      // vert pass
      for (i = 0; i < w; ++i) {
        sum = dst_d[i];
        for (j = 0; j < half_kernel; ++j) {
          buf[j] = sum;
        }
        k = i;
        for (j = 0; j <= h - 2; j += 2, k += w2) {
          buf[j + half_kernel] = dst_d[k];
          buf[j + half_kernel + 1] = dst_d[k + w];
        }
        for (; j < h; ++j, k += w) {
          buf[j + half_kernel] = dst_d[k];
        }
        sum = dst_d[(h - 1) * w + i];
        for (j = h; j < half_kernel + h; ++j) {
          buf[j + half_kernel] = sum;
        }
        dp = i;
        for (j = 0; j <= h - 4; j += 4, dp += w4) {
          (sum = buf[j] * f0),
            (sum1 = buf[j + 1] * f0),
            (sum2 = buf[j + 2] * f0),
            (sum3 = buf[j + 3] * f0);
          for (k = 1; k < kernel_size; ++k) {
            fk = filter[k];
            sum += buf[k + j] * fk;
            sum1 += buf[k + j + 1] * fk;
            sum2 += buf[k + j + 2] * fk;
            sum3 += buf[k + j + 3] * fk;
          }
          dst_d[dp] = sum;
          dst_d[dp + w] = sum1;
          dst_d[dp + w2] = sum2;
          dst_d[dp + w3] = sum3;
        }
        for (; j < h; ++j, dp += w) {
          sum = buf[j] * f0;
          for (k = 1; k < kernel_size; ++k) {
            sum += buf[k + j] * filter[k];
          }
          dst_d[dp] = sum;
        }
      }
    };

    return {
      // grayscale
      gs: function(src, w, h, dst, code) {
        // this is default image data representation in browser
        if (typeof code === 'undefined') {
          code = jsfeat.COLOR_RGBA2GRAY;
        }
        var x = 0,
          y = 0,
          i = 0,
          j = 0,
          ir = 0,
          jr = 0;
        var coeff_r = 4899,
          coeff_g = 9617,
          coeff_b = 1868,
          cn = 4;

        if (code == jsfeat.COLOR_BGRA2GRAY || code == jsfeat.COLOR_BGR2GRAY) {
          coeff_r = 1868;
          coeff_b = 4899;
        }
        if (code == jsfeat.COLOR_RGB2GRAY || code == jsfeat.COLOR_BGR2GRAY) {
          cn = 3;
        }
        var cn2 = cn << 1,
          cn3 = (cn * 3) | 0;

        dst.resize(w, h, 1);
        var dst_u8 = dst.data;

        for (y = 0; y < h; ++y, j += w, i += w * cn) {
          for (
            x = 0, ir = i, jr = j;
            x <= w - 4;
            x += 4, ir += cn << 2, jr += 4
          ) {
            dst_u8[jr] =
              (src[ir] * coeff_r +
                src[ir + 1] * coeff_g +
                src[ir + 2] * coeff_b +
                8192) >>
              14;
            dst_u8[jr + 1] =
              (src[ir + cn] * coeff_r +
                src[ir + cn + 1] * coeff_g +
                src[ir + cn + 2] * coeff_b +
                8192) >>
              14;
            dst_u8[jr + 2] =
              (src[ir + cn2] * coeff_r +
                src[ir + cn2 + 1] * coeff_g +
                src[ir + cn2 + 2] * coeff_b +
                8192) >>
              14;
            dst_u8[jr + 3] =
              (src[ir + cn3] * coeff_r +
                src[ir + cn3 + 1] * coeff_g +
                src[ir + cn3 + 2] * coeff_b +
                8192) >>
              14;
          }
          for (; x < w; ++x, ++jr, ir += cn) {
            dst_u8[jr] =
              (src[ir] * coeff_r +
                src[ir + 1] * coeff_g +
                src[ir + 2] * coeff_b +
                8192) >>
              14;
          }
        }
      },
      // gaussian_blur
      gb: function(src, dst, kernel_size, sigma) {
        if (typeof sigma === 'undefined') {
          sigma = 0.0;
        }
        if (typeof kernel_size === 'undefined') {
          kernel_size = 0;
        }
        kernel_size =
          kernel_size == 0
            ? (Math.max(1, 4.0 * sigma + 1.0 - 1e-8) * 2 + 1) | 0
            : kernel_size;
        var half_kernel = kernel_size >> 1;
        var w = src.cols,
          h = src.rows;
        var data_type = src.type,
          is_u8 = data_type & jsfeat.U8_t;

        dst.resize(w, h, src.channel);

        var src_d = src.data,
          dst_d = dst.data;
        var buf,
          filter,
          buf_sz = (kernel_size + Math.max(h, w)) | 0;

        var buf_node = jsfeat.cache.get_buffer(buf_sz << 2);
        var filt_node = jsfeat.cache.get_buffer(kernel_size << 2);

        if (is_u8) {
          buf = buf_node.i32;
          filter = filt_node.i32;
        } else if (data_type & jsfeat.S32_t) {
          buf = buf_node.i32;
          filter = filt_node.f32;
        } else {
          buf = buf_node.f32;
          filter = filt_node.f32;
        }

        jsfeat.math.get_gaussian_kernel(kernel_size, sigma, filter, data_type);

        if (is_u8) {
          _convol_u8(buf, src_d, dst_d, w, h, filter, kernel_size, half_kernel);
        } else {
          _convol(buf, src_d, dst_d, w, h, filter, kernel_size, half_kernel);
        }

        jsfeat.cache.put_buffer(buf_node);
        jsfeat.cache.put_buffer(filt_node);
      },

      // compute gradient using Sobel kernel [1 2 1] * [-1 0 1]^T
      // dst: [gx,gy,...]
      sobel_derivatives: function(src, dst) {
        var w = src.cols,
          h = src.rows;
        var dstep = w << 1,
          x = 0,
          y = 0,
          x1 = 0,
          a,
          b,
          c,
          d,
          e,
          f;
        var srow0 = 0,
          srow1 = 0,
          srow2 = 0,
          drow = 0;
        var trow0, trow1;

        dst.resize(w, h, 2); // 2 channel output gx, gy

        var img = src.data,
          gxgy = dst.data;

        var buf0_node = jsfeat.cache.get_buffer((w + 2) << 2);
        var buf1_node = jsfeat.cache.get_buffer((w + 2) << 2);

        if (src.type & jsfeat.U8_t || src.type & jsfeat.S32_t) {
          trow0 = buf0_node.i32;
          trow1 = buf1_node.i32;
        } else {
          trow0 = buf0_node.f32;
          trow1 = buf1_node.f32;
        }

        for (; y < h; ++y, srow1 += w) {
          srow0 = ((y > 0 ? y - 1 : 1) * w) | 0;
          srow2 = ((y < h - 1 ? y + 1 : h - 2) * w) | 0;
          drow = (y * dstep) | 0;
          // do vertical convolution
          for (x = 0, x1 = 1; x <= w - 2; x += 2, x1 += 2) {
            (a = img[srow0 + x]), (b = img[srow2 + x]);
            trow0[x1] = a + b + img[srow1 + x] * 2;
            trow1[x1] = b - a;
            //
            (a = img[srow0 + x + 1]), (b = img[srow2 + x + 1]);
            trow0[x1 + 1] = a + b + img[srow1 + x + 1] * 2;
            trow1[x1 + 1] = b - a;
          }
          for (; x < w; ++x, ++x1) {
            (a = img[srow0 + x]), (b = img[srow2 + x]);
            trow0[x1] = a + b + img[srow1 + x] * 2;
            trow1[x1] = b - a;
          }
          // make border
          x = (w + 1) | 0;
          trow0[0] = trow0[1];
          trow0[x] = trow0[w];
          trow1[0] = trow1[1];
          trow1[x] = trow1[w];
          // do horizontal convolution, interleave the results and store them
          for (x = 0; x <= w - 4; x += 4) {
            (a = trow1[x + 2]),
              (b = trow1[x + 1]),
              (c = trow1[x + 3]),
              (d = trow1[x + 4]),
              (e = trow0[x + 2]),
              (f = trow0[x + 3]);
            gxgy[drow++] = e - trow0[x];
            gxgy[drow++] = a + trow1[x] + b * 2;
            gxgy[drow++] = f - trow0[x + 1];
            gxgy[drow++] = c + b + a * 2;

            gxgy[drow++] = trow0[x + 4] - e;
            gxgy[drow++] = d + a + c * 2;
            gxgy[drow++] = trow0[x + 5] - f;
            gxgy[drow++] = trow1[x + 5] + c + d * 2;
          }
          for (; x < w; ++x) {
            gxgy[drow++] = trow0[x + 2] - trow0[x];
            gxgy[drow++] = trow1[x + 2] + trow1[x] + trow1[x + 1] * 2;
          }
        }
        jsfeat.cache.put_buffer(buf0_node);
        jsfeat.cache.put_buffer(buf1_node);
      },
      // canny
      cy: function(src, dst, low_thresh, high_thresh) {
        var w = src.cols,
          h = src.rows,
          src_d = src.data;

        dst.resize(w, h, src.channel);

        var dst_d = dst.data;
        var i = 0,
          j = 0,
          grad = 0,
          w2 = w << 1,
          _grad = 0,
          suppress = 0,
          f = 0,
          x = 0,
          y = 0,
          s = 0;
        var tg22x = 0,
          tg67x = 0;

        // cache buffers
        var dxdy_node = jsfeat.cache.get_buffer((h * w2) << 2);
        var buf_node = jsfeat.cache.get_buffer((3 * (w + 2)) << 2);
        var map_node = jsfeat.cache.get_buffer(((h + 2) * (w + 2)) << 2);
        var stack_node = jsfeat.cache.get_buffer((h * w) << 2);

        var buf = buf_node.i32;
        var map = map_node.i32;
        var stack = stack_node.i32;
        var dxdy = dxdy_node.i32;
        var dxdy_m = new jsfeat.matrix_t(w, h, jsfeat.S32C2_t, dxdy_node.data);
        var row0 = 1,
          row1 = (w + 2 + 1) | 0,
          row2 = (2 * (w + 2) + 1) | 0,
          map_w = (w + 2) | 0,
          map_i = (map_w + 1) | 0,
          stack_i = 0;

        this.sobel_derivatives(src, dxdy_m);

        if (low_thresh > high_thresh) {
          i = low_thresh;
          low_thresh = high_thresh;
          high_thresh = i;
        }

        i = (3 * (w + 2)) | 0;
        while (--i >= 0) {
          buf[i] = 0;
        }

        i = ((h + 2) * (w + 2)) | 0;
        while (--i >= 0) {
          map[i] = 0;
        }

        for (; j < w; ++j, grad += 2) {
          //buf[row1+j] = Math.abs(dxdy[grad]) + Math.abs(dxdy[grad+1]);
          (x = dxdy[grad]), (y = dxdy[grad + 1]);
          //buf[row1+j] = x*x + y*y;
          buf[row1 + j] =
            (x ^ (x >> 31)) - (x >> 31) + ((y ^ (y >> 31)) - (y >> 31));
        }

        for (i = 1; i <= h; ++i, grad += w2) {
          if (i == h) {
            j = row2 + w;
            while (--j >= row2) {
              buf[j] = 0;
            }
          } else {
            for (j = 0; j < w; j++) {
              //buf[row2+j] =  Math.abs(dxdy[grad+(j<<1)]) + Math.abs(dxdy[grad+(j<<1)+1]);
              (x = dxdy[grad + (j << 1)]), (y = dxdy[grad + (j << 1) + 1]);
              //buf[row2+j] = x*x + y*y;
              buf[row2 + j] =
                (x ^ (x >> 31)) - (x >> 31) + ((y ^ (y >> 31)) - (y >> 31));
            }
          }
          _grad = (grad - w2) | 0;
          map[map_i - 1] = 0;
          suppress = 0;
          for (j = 0; j < w; ++j, _grad += 2) {
            f = buf[row1 + j];
            if (f > low_thresh) {
              x = dxdy[_grad];
              y = dxdy[_grad + 1];
              s = x ^ y;
              // seems ot be faster than Math.abs
              x = ((x ^ (x >> 31)) - (x >> 31)) | 0;
              y = ((y ^ (y >> 31)) - (y >> 31)) | 0;
              //x * tan(22.5) x * tan(67.5) == 2 * x + x * tan(22.5)
              tg22x = x * 13573;
              tg67x = tg22x + ((x + x) << 15);
              y <<= 15;
              if (y < tg22x) {
                if (f > buf[row1 + j - 1] && f >= buf[row1 + j + 1]) {
                  if (
                    f > high_thresh &&
                    !suppress &&
                    map[map_i + j - map_w] != 2
                  ) {
                    map[map_i + j] = 2;
                    suppress = 1;
                    stack[stack_i++] = map_i + j;
                  } else {
                    map[map_i + j] = 1;
                  }
                  continue;
                }
              } else if (y > tg67x) {
                if (f > buf[row0 + j] && f >= buf[row2 + j]) {
                  if (
                    f > high_thresh &&
                    !suppress &&
                    map[map_i + j - map_w] != 2
                  ) {
                    map[map_i + j] = 2;
                    suppress = 1;
                    stack[stack_i++] = map_i + j;
                  } else {
                    map[map_i + j] = 1;
                  }
                  continue;
                }
              } else {
                s = s < 0 ? -1 : 1;
                if (f > buf[row0 + j - s] && f > buf[row2 + j + s]) {
                  if (
                    f > high_thresh &&
                    !suppress &&
                    map[map_i + j - map_w] != 2
                  ) {
                    map[map_i + j] = 2;
                    suppress = 1;
                    stack[stack_i++] = map_i + j;
                  } else {
                    map[map_i + j] = 1;
                  }
                  continue;
                }
              }
            }
            map[map_i + j] = 0;
            suppress = 0;
          }
          map[map_i + w] = 0;
          map_i += map_w;
          j = row0;
          row0 = row1;
          row1 = row2;
          row2 = j;
        }

        j = map_i - map_w - 1;
        for (i = 0; i < map_w; ++i, ++j) {
          map[j] = 0;
        }
        // path following
        while (stack_i > 0) {
          map_i = stack[--stack_i];
          map_i -= map_w + 1;
          if (map[map_i] == 1) (map[map_i] = 2), (stack[stack_i++] = map_i);
          map_i += 1;
          if (map[map_i] == 1) (map[map_i] = 2), (stack[stack_i++] = map_i);
          map_i += 1;
          if (map[map_i] == 1) (map[map_i] = 2), (stack[stack_i++] = map_i);
          map_i += map_w;
          if (map[map_i] == 1) (map[map_i] = 2), (stack[stack_i++] = map_i);
          map_i -= 2;
          if (map[map_i] == 1) (map[map_i] = 2), (stack[stack_i++] = map_i);
          map_i += map_w;
          if (map[map_i] == 1) (map[map_i] = 2), (stack[stack_i++] = map_i);
          map_i += 1;
          if (map[map_i] == 1) (map[map_i] = 2), (stack[stack_i++] = map_i);
          map_i += 1;
          if (map[map_i] == 1) (map[map_i] = 2), (stack[stack_i++] = map_i);
        }

        map_i = map_w + 1;
        row0 = 0;
        for (i = 0; i < h; ++i, map_i += map_w) {
          for (j = 0; j < w; ++j) {
            dst_d[row0++] = (map[map_i + j] == 2) * 0xff;
          }
        }

        // free buffers
        jsfeat.cache.put_buffer(dxdy_node);
        jsfeat.cache.put_buffer(buf_node);
        jsfeat.cache.put_buffer(map_node);
        jsfeat.cache.put_buffer(stack_node);
      }
    };
  })();

  global.imgproc = imgproc;
})(jsfeat);

/**
 * @author Eugene Zatepyakin / http://inspirit.ru/
 */

(function(lib) {
  'use strict';

  if (typeof module === 'undefined' || typeof module.exports === 'undefined') {
    // in a browser, define its namespaces in global
    window.jsfeat = lib;
  } else {
    // in commonjs, or when AMD wrapping has been applied, define its namespaces as exports
    module.exports = lib;
  }
})(jsfeat);
